// src/hooks/useSuggestions.ts
import { useQuery } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";

const API = process.env.REACT_APP_API;

export interface Suggestion {
  id: number;
  type: "order" | "farmerorder";
  label: string;
}

export function useSuggestions(term: string) {
  const fetch = useFetch();
  return useQuery({
    queryKey: ["suggestions", term],
    queryFn: async () => {
      const params = new URLSearchParams({ q: term });
      return (await fetch(
        `${API}/api/semeadora/search/suggestions/?${params.toString()}`,
      )) as Suggestion[];
    },
    enabled: term.length >= 2,
    staleTime: 60 * 1000,
  });
}
